/** Класс мобильного меню. */
class BurgerMenu {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        
        this.findStaticElements();
        this.bindEventListeners();
    }

    /**
     * Поиск неизменных элементов.
     *
     * @returns {void}
     */
    findStaticElements() {
        this.header = this.el.closest(".js-mch-header");
        this.burgerButtons = this.header.getElementsByClassName("js-mch-burger-button-menu");
    }

    /**
     * Отслеживание событий.
     *
     * @returns {void}
     */
    bindEventListeners() {
        [...this.burgerButtons].forEach(button => {
            button.addEventListener("click", this.toggleVisibilityMenu.bind(this));
        }) 
    }

    /**
     * Переключение видимости мобильного меню.
     *
     * @returns {void}
     */
    toggleVisibilityMenu() {
        this.header.classList.toggle("is-menu-open");

        if (document.documentElement.classList.contains("prevent-scroll")) {
            document.documentElement.classList.remove("prevent-scroll");
        } else {
            document.documentElement.classList.add("prevent-scroll");
        }

        if (this.el.classList.contains("is-open")) {
            this.el.classList.remove("is-open");
        } else {
            this.el.classList.add("is-open");
        }
    }
}

document.querySelectorAll(".js-mch-burger-menu").forEach((button) => new BurgerMenu(button));